import LTPlatform from "../../LTGame/Platform/LTPlatform";
import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import UI_Revive from "../../ui/Main/UI_Revive";
import GlobalUnit from "../common/GlobalUnit";
import { GameConst } from "../config/GameConst";
import { EPlatformType } from "../../LTGame/Platform/EPlatformType";
export class UI_ReviveMediator extends BaseUIMediator {
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_ReviveMediator();
            this._instance._classDefine = UI_Revive;
        }
        return this._instance;
    }
    _OnShow() {
        super._OnShow();
        this.ui.m_btn_get.onClick(this, this.OnRevive);
        this.ui.m_btn_close.onClick(this, this.OnClose);
        this.cacheTime = GameConst.data.revive_hide_time;
        this.RefreshTime();
        LTPlatform.instance.RecordEvent('game_ad_show', {
            level_id: GlobalUnit.game.level.config.id,
            id: 'relive'
        });
        if (LTPlatform.instance.platform == EPlatformType.WX) {
            LTPlatform.instance.OpenGameBox();
        }
    }
    RefreshTime() {
        if (this.cacheTime <= 0) {
            this.OnClose();
            return;
        }
        this.ui.m_com_time.m_text_time.text = this.cacheTime.toString();
        this.cacheTime--;
        Laya.timer.once(1000, this, this.RefreshTime);
    }
    OnRevive() {
        return __awaiter(this, void 0, void 0, function* () {
            Laya.timer.clear(this, this.RefreshTime);
            GlobalUnit.game.Pause();
            let res = yield LTPlatform.instance.ShowRewardVideoAdAsync();
            if (res) {
                LTPlatform.instance.RecordEvent('game_ad', {
                    level_id: GlobalUnit.game.level.config.id,
                    id: 'relive'
                });
                GlobalUnit.game.OnRevive();
                this.Hide();
            }
            else {
                Laya.timer.once(1000, this, this.RefreshTime);
            }
            GlobalUnit.game.Resume();
        });
    }
    OnClose() {
        this.Hide();
        // UI_FailMediator.instance.Show();
        GlobalUnit.game.ShowResult();
        if (LTPlatform.instance.platform == EPlatformType.WX) {
            LTPlatform.instance.HideGameBox();
        }
    }
    _OnHide() {
        Laya.timer.clearAll(this);
    }
}
